import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import React from 'react';
import ProgressPotentialDial from 'components/PaymentHistoryDial/ProgressPotentialDial';
import './PaymentHistorySummaryModule.scss';
import classNames from 'classnames';
import { FACTOR_ENUMS } from 'pages/RedesignDashboard/constants';
import { useConfig } from 'hook/config.hook';

const PaymentHistorySummaryModuleView = props => {
  const { additionalData, selectedFactorGrade } = props;
  const paymentHistorySummary = additionalData?.paymentHistorySummary;
  const { PAYMENT_HISTORY } = FACTOR_ENUMS;
  const { config } = useConfig();

  const label =
    config?.summaryHeaders?.[PAYMENT_HISTORY][selectedFactorGrade || 'DEFAULT'];

  return (
    <FlexContainer
      className={
        'paymentHistorySummaryModuleContainer flex-column margt24 marglr48 m-marglr16'
      }
    >
      <Label type="Body-2 ">{label}</Label>
      <FlexContainer className={'margt24 gap-12'}>
        <ProgressPotentialDial
          size={'small'}
          totalCurrentTradelineCount={
            paymentHistorySummary?.totalCurrentTradelineCount
          }
          delinquentTradelineCount={
            paymentHistorySummary?.delinquentTradelineCount
          }
          derogatoryTradelineCount={
            paymentHistorySummary?.derogatoryTradelineCount
          }
          trailColor="#ececec" // bgGrayN050
          successStrokeColor="#ffdb72" // bgYellow075
          strokeColor="#f88320" // bgOrange3
        />
        <FlexContainer className={'flex-column justify-around width100'}>
          <LeyendRow
            label="Current"
            dialBgColor="bgGrayN050"
            tradeLineCount={paymentHistorySummary?.totalCurrentTradelineCount}
          />
          <LeyendRow
            label="Delinquent"
            dialBgColor="bgYellow075"
            tradeLineCount={paymentHistorySummary?.delinquentTradelineCount}
          />
          <LeyendRow
            label="Derogatory"
            dialBgColor="bgOrange3"
            tradeLineCount={paymentHistorySummary?.derogatoryTradelineCount}
          />
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

const LeyendRow = props => {
  const { dialBgColor, label, tradeLineCount } = props;

  const dialBgClassName = classNames(
    dialBgColor,
    'dialCustomUl marglr4 border-rad8px',
  );

  return (
    <FlexContainer className={'width100 justify-between items-align-center'}>
      <FlexContainer className="items-align-center">
        <span className={dialBgClassName} />
        <Label className="Subtitle2 caption ">{label}</Label>
      </FlexContainer>

      <FlexContainer
        className={'format70 m-format45 items-align-center justify-between'}
      >
        <FlexContainer className={'dottedLine format90 m-format70'} />
        <Label type="Subtitle2 caption" className={'bold'}>
          {tradeLineCount}
        </Label>
      </FlexContainer>
    </FlexContainer>
  );
};

export default PaymentHistorySummaryModuleView;
